import React, { useEffect, useState, useRef } from "react"
import { Alert, Card, Col, Container, Row } from "react-bootstrap"
import { CSSTransition } from "react-transition-group"
import { useParams, useNavigate } from "react-router-dom"
import { fetchAPIData, isLoggedIn, notAuthorized } from "../../api/AuthService"
import { DefaultKeys, FETCH_SBV, SBVKeys } from "../../constant/Constants"
import Attributes from "../commonComponents/Attributes"
import { errorHandling, handleClick, pdfData } from "../commonComponents/EventHandler"
import HeaderComponent from "../commonComponents/HeaderComponent"
import PdfDownloadComponent from "../commonComponents/PdfDownloadComponent"
import SideNav from "../commonComponents/SideNav"
import SingleColumnAttributes from "../commonComponents/SingleColumnAttributes"
import TopContent from "../commonComponents/TopContentForSpecs"
import GenDocsFileDownTable from "../commonComponents/GenDocsFilesDownload"

function SbvAllinfo(props) {
   const { objectID, searchId, partName } = useParams()
   const navigate = useNavigate()
   const nodeRef = useRef(null)
   const [data, setData] = useState({
      headerContent: {},
      attributeObject: {},
      generalInformation: {},
      productEffectivity: {},
      asdesignedPartInformation: {},
      customerInformation: {},
      distributions:[],
      accessControl: {},
      buildingPlanning: {},
      whereUsed: null,
   })

   const [loading, setLoading] = useState(true)
   const searchData = searchId || objectID
   const [sideNav, setSideNav] = useState(null)
   const [inProp, setInProp] = useState(false)
   
   // Initialize selectedItems with both DefaultKeys and all SBV keys set to true
   const [selectedItems, setSelectedItems] = useState({
      ...DefaultKeys,
      generalInformation: true,
      productEffectivity: true,
      asdesignedPartInformation: true,
      customerInformation: true,
      accessControl: true,
      buildingPlanning: true,
      distributions: true,
      whereUsed: true,
   })
   
   const [pdfDataSet, setPdfDataSet] = useState({})

   const handleSelectedItems = (obj, IsFilterView) => {
      setSelectedItems(obj)
      var values = pdfData(data, obj, IsFilterView)
      setPdfDataSet(values)
   }

   useEffect(() => {
      const fetchState = { cancel: false }
      if (!isLoggedIn()) {
         navigate("/")
      } else {
         async function fetchSbvData(fetchState) {
            try {
               setLoading(true)
               setInProp(true)
               setSideNav(null)
               var apiData

               if (
                  !partName &&
                  sessionStorage.getItem(searchData) &&
                  sessionStorage.getItem(searchData) !== ""
               ) {
                  apiData = JSON.parse(sessionStorage.getItem(searchData))
               } else {
                  // Load async data from an Fpp Api endpoint.
                  const response = await fetchAPIData(`${FETCH_SBV}/${searchData}${partName ? `/${partName}` : ''}`)
                  apiData = response.data
                  if (apiData.headerContent)
                     sessionStorage.setItem(searchData, JSON.stringify(response.data))
               }

               if (fetchState.cancel) {
                  return
               }
               
               
               
               setData({
                  headerContent: apiData.headerContent,
                  attributeObject: apiData.changeManagement,
                  generalInformation: apiData.generalInformation,
                  productEffectivity: apiData.productEffectivity,
                  asdesignedPartInformation: apiData.asdesignedPartInformation,
                  customerInformation: apiData.customerInformation,
                  distributions: apiData.distributions,
                  accessControl: apiData.accessControl,
                  buildingPlanning: apiData.buildingPlanning,
                  whereUsed: apiData.whereUsed,
               })
               setLoading(false)
            } catch (error) {
               // setError(error)
               if (error.response && error.response.data.status === 401) {
                  notAuthorized(navigate)
                  return
               }
               setLoading(false)
               errorHandling(error, navigate)
            }
         }
         window.scrollTo(0, 0)
         fetchSbvData(fetchState)
      }

      return () => {
         fetchState.cancel = true
      }
   }, [searchData, navigate])

   useEffect(() => {
      if (!loading && data.headerContent && data.headerContent?.Name) {
         // Wait for DOM to render
         setTimeout(() => {
            setNavigation()
         }, 100)
      }
   }, [loading, data])

   function setNavigation() {
      const sideNavObj = document.getElementsByClassName("accordionStyle")
      
      
      if (sideNavObj && sideNavObj.length > 0) {
         const sideNavArray = Array.from(sideNavObj)
         
         setSideNav(sideNavArray)
      } else {
         console.log("No accordion elements found!")
      }
   }

   return (
      <React.Fragment>
         <HeaderComponent name={partName ? decodeURIComponent(partName) : data.headerContent?.Name} pdfDataSet={pdfDataSet} />
         <CSSTransition timeout={300} in={inProp} classNames="my-node" nodeRef={nodeRef}>
            <Container fluid ref={nodeRef}>
               <Row>
                  <Col sm="3" md="2" className="leftSection">
                     <br />
                     <Col sm="3" md="2" className="labels sideNav">
                        {!loading && data.headerContent && data.headerContent?.Name && (
                           <div>
                              <p style={{ marginLeft: "15px" }}>
                                 Name : {data.headerContent?.Name} <br />
                                 Revision : {data.headerContent?.Revision}
                              </p>
                              {sideNav && sideNav.length > 0 ? (
                                 <SideNav
                                    data={sideNav}
                                    handler={handleSelectedItems}
                                    resData={data}
                                    Keys={SBVKeys}
                                    Name={data.headerContent?.Name}
                                    searchData={searchData}
                                    Revision={data.headerContent?.Revision}
                                    whereUsed={data.whereUsed}
                                 />
                              ) : (
                                 <p style={{ color: 'red', marginLeft: '15px' }}>
                                    No categories found
                                 </p>
                              )}
                           </div>
                        )}
                     </Col>
                  </Col>
                  <Col sm="9" md="10" id="print" className="contentBackground">
                     <br />
                     {!loading && data.headerContent && data.headerContent?.Name ? (
                        <Row id="data">
                           <Col md="9" sm="9">
                              <TopContent headerContent={data.headerContent} />
                           </Col>
                           <Col md="3" sm="3" align="right">
                              <PdfDownloadComponent
                                 pdfDataSet={pdfDataSet}
                                 pdfHide={true}
                                 genDocHide={true}
                              />
                           </Col>
                        </Row>
                     ) : (
                        !loading && (
                           <div>
                              <Alert variant="info">
                                 <p style={{ marginLeft: "30rem" }}>
                                    {" "}
                                    No data available to show.
                                 </p>
                              </Alert>
                           </div>
                        )
                     )}
                     <br />
                     <Row>
                        <Col md="12" className="dataCol contentBackground">
                           {
                              selectedItems["generalInformation"] && (
                                 <div>
                                    <Card>
                                       <Card.Body
                                          className="accordionStyle"
                                          onClick={handleClick.bind(this, "1", "one")}
                                          aria-controls="one"
                                       >
                                          {SBVKeys.generalInformation}{" "}
                                          <i
                                             id="1"
                                             name="accordItem"
                                             className="fa fa-minus-circle accordIconStyle"
                                          ></i>
                                       </Card.Body>
                                    </Card>
                                    <div
                                       className="accordionDiv shadow"
                                       id="one"
                                       name="collapseItem"
                                       style={{ display: "block" }}
                                    >
                                       <Attributes
                                          loading = {loading}
                                          data={data.generalInformation} />
                                    </div>
                                 </div>
                              )}
                           {!loading &&
                              data.productEffectivity &&
                              Object.keys(data.productEffectivity).length > 0 &&
                              selectedItems["productEffectivity"] && (
                                 <div>
                                    <Card>
                                       <Card.Body
                                          className="accordionStyle"
                                          onClick={handleClick.bind(this, "2", "two")}
                                          aria-controls="two"
                                       >
                                          {SBVKeys.productEffectivity}{" "}
                                          <i
                                             id="2"
                                             name="accordItem"
                                             className="fa fa-minus-circle accordIconStyle"
                                          ></i>
                                       </Card.Body>
                                    </Card>
                                    <div
                                       className="accordionDiv shadow"
                                       id="two"
                                       name="collapseItem"
                                       style={{ display: "block" }}
                                    >
                                       <SingleColumnAttributes
                                          data={data.productEffectivity}
                                       />
                                    </div>
                                 </div>
                              )}
                           {!loading &&
                              data.asdesignedPartInformation &&
                              Object.keys(data.asdesignedPartInformation).length > 0 &&
                              selectedItems["asdesignedPartInformation"] && (
                                 <div>
                                    <Card>
                                       <Card.Body
                                          className="accordionStyle"
                                          onClick={handleClick.bind(this, "3", "three")}
                                          aria-controls="three"
                                       >
                                          {SBVKeys.asdesignedPartInformation}{" "}
                                          <i
                                             id="3"
                                             name="accordItem"
                                             className="fa fa-minus-circle accordIconStyle"
                                          ></i>
                                       </Card.Body>
                                    </Card>
                                    <div
                                       className="accordionDiv shadow"
                                       id="three"
                                       name="collapseItem"
                                       style={{ display: "block" }}
                                    >
                                       <Attributes
                                          data={data.asdesignedPartInformation}
                                       />
                                    </div>
                                 </div>
                              )}
                           {!loading &&
                              data.customerInformation &&
                              Object.keys(data.customerInformation).length > 0 &&
                              selectedItems["customerInformation"] && (
                                 <div>
                                    <Card>
                                       <Card.Body
                                          className="accordionStyle"
                                          onClick={handleClick.bind(this, "4", "four")}
                                          aria-controls="four"
                                       >
                                          {SBVKeys.customerInformation}{" "}
                                          <i
                                             id="4"
                                             name="accordItem"
                                             className="fa fa-minus-circle accordIconStyle"
                                          ></i>
                                       </Card.Body>
                                    </Card>
                                    <div
                                       className="accordionDiv shadow"
                                       id="four"
                                       name="collapseItem"
                                       style={{ display: "block" }}
                                    >
                                       <SingleColumnAttributes
                                          data={data.customerInformation}
                                       />
                                    </div>
                                 </div>
                              )}
                           {!loading &&
                              data.accessControl &&
                              Object.keys(data.accessControl).length > 0 &&
                              selectedItems["accessControl"] && (
                                 <div>
                                    <Card>
                                       <Card.Body
                                          className="accordionStyle"
                                          onClick={handleClick.bind(this, "5", "five")}
                                          aria-controls="five"
                                       >
                                          {SBVKeys.accessControl}{" "}
                                          <i
                                             id="5"
                                             name="accordItem"
                                             className="fa fa-minus-circle accordIconStyle"
                                          ></i>
                                       </Card.Body>
                                    </Card>
                                    <div
                                       className="accordionDiv shadow"
                                       id="five"
                                       name="collapseItem"
                                       style={{ display: "block" }}
                                    >
                                       <SingleColumnAttributes
                                          data={data.accessControl}
                                       />
                                    </div>
                                 </div>
                              )}
                           {!loading &&
                              data.buildingPlanning &&
                              Object.keys(data.buildingPlanning).length > 0 &&
                              selectedItems["buildingPlanning"] && (
                                 <div>
                                    <Card>
                                       <Card.Body
                                          className="accordionStyle"
                                          onClick={handleClick.bind(this, "6", "six")}
                                          aria-controls="six"
                                       >
                                          {SBVKeys.buildingPlanning}{" "}
                                          <i
                                             id="6"
                                             name="accordItem"
                                             className="fa fa-minus-circle accordIconStyle"
                                          ></i>
                                       </Card.Body>
                                    </Card>
                                    <div
                                       className="accordionDiv shadow"
                                       id="six"
                                       name="collapseItem"
                                       style={{ display: "block" }}
                                    >
                                       <SingleColumnAttributes
                                          data={data.buildingPlanning}
                                       />
                                    </div>
                                 </div>
                              )}
                              {!loading &&
                                 data.distributions &&
                                 data.distributions?.length > 0 &&
                                 selectedItems["distributions"] && (
                                    <div>
                                       <Card>
                                          <Card.Body
                                             className="accordionStyle"
                                             onClick={handleClick.bind(this, "7", "seven")}
                                             aria-controls="seven"
                                          >
                                             {SBVKeys.distributions}{" "}
                                             <i
                                                id="7"
                                                name="accordItem"
                                                className="fa fa-minus-circle accordIconStyle"
                                             ></i>
                                          </Card.Body>
                                       </Card>
                                       <div
                                          className="accordionDiv shadow"
                                          id="seven"
                                          name="collapseItem"
                                          style={{ display: "block" }}
                                       >
                                          <GenDocsFileDownTable
                                             data={data.distributions}
                                             attributes={data.attributes}
                                             headerContent={data.headerContent}
                                          />
                                       </div>
                                    </div>
                                    
                                 )}
                              {!loading &&
                              data.whereUsed !== null &&
                              selectedItems["whereUsed"] && (
                                 <div style={{ display: "none" }}>
                                    <Card>
                                       <Card.Body
                                          className="accordionStyle"
                                          onClick={handleClick.bind(
                                             this,
                                             "36",
                                             "thirtysix"
                                          )}
                                          aria-controls="thirtysix"
                                       >
                                          {SBVKeys.whereUsed}{" "}
                                       </Card.Body>
                                    </Card>
                                    <div
                                       id="thirtysix"
                                       name="collapseItem"
                                       style={{ display: "none" }}
                                    ></div>
                                 </div>
                              )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </Container>
         </CSSTransition>
      </React.Fragment>
   )
}
export default SbvAllinfo